import { DTOCor } from './dtoCor';
export class DTOListaCatalogo {    
    IdEmpresa: number;    
    Referencia: string;
    Descricao: string;
    QtdePicote: number; 
    DTOCor: DTOCor[];
    Img: string;
    Preco: number; 
    Grupo: string;
    
    deserialize(input: Object): DTOListaCatalogo {
        Object.assign(this, input);

        return this;
    }
}


// WEBPACK FOOTER //
// ./src/dto/dtoListaCatalogo.ts